// eslint-disable-next-line no-unused-vars
import React, { memo, useState } from 'react';

import useUser from 'Hooks/useUser';
import useFetch from 'Hooks/useFetch';
import useAsyncError from 'Hooks/useAsyncError';
import CookieConsentComponent from 'Components/CookieConsent/CookieConsent';
import { API_COOKIE_POLICY } from 'Constants';

const ACCEPTED = 1;

const CookieConsent = memo(() => {
  const [isLoading, setIsLoading] = useState(false);

  const { data: user = {}, setUserData } = useUser();
  const fetcher = useFetch();
  const throwError = useAsyncError();

  const handleConsent = async () => {
    setIsLoading(true);
    fetcher(API_COOKIE_POLICY, {
      method: 'POST',
      body: JSON.stringify({ cookiePolicy: ACCEPTED })
    }).then(() => setUserData({ cookiePolicy: ACCEPTED }))
      .catch(err => throwError(err))
      .finally(() => setIsLoading(false));
  };

  return (user?.email && !user?.cookiePolicy) && <CookieConsentComponent onClick={ handleConsent } isLoading={ isLoading } />;
});

CookieConsent.displayName = 'CookieConsentContainer';

export default CookieConsent;
